import Input from "@mui/material/Input";
import { makeStyles } from "components/mui-core";
import { grayColor, primaryColor } from "vendor/colors";

const useStyles = makeStyles()({
  box: {
    justifyContent: "space-between",
    width: 45,
    height: 45,
    margin: 5,
    borderRadius: 5,
    border: `1px solid ${grayColor[0]}`,
  },
  input: {
    textAlign: "center",
  },
  underline: {
    "&:after": {
      borderBottom: `2px solid ${primaryColor[0]}`,
    },
    "&:hover": {
      "&:not(.Mui-disabled)": {
        "&:before": {
          borderBottom: `1px solid black`,
        },
      },
    },
  },
});

type IProps = {
  autoFocus?: boolean;
  name: string;
  handleKeyDown: (e: any) => void;
  handleFocus: (e: any) => void;
  handleChange: (e: any) => void;
  boxRef: any;
  inputProps?: any;
  dataQa?: string;
};

function InputBox({
  autoFocus,
  handleChange,
  handleKeyDown,
  handleFocus,
  name,
  boxRef,
  inputProps,
  dataQa = "input-box",
}: IProps) {
  const { classes } = useStyles();

  return (
    <Input
      {...inputProps}
      data-qa={dataQa}
      autoFocus={autoFocus}
      className={classes.box}
      classes={{
        input: classes.input,
        underline: classes.underline,
      }}
      type="text"
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      onFocus={handleFocus}
      maxLength="1"
      name={name}
      ref={boxRef}
    />
  );
}

export default InputBox;
